import React from "react";
import { MessageCircle } from "lucide-react";
import { useSettings } from "../settings";

const waNormalize = (raw) => {
  if (!raw) return "";
  const digits = raw.replace(/[^0-9]/g, "");
  return digits;
};

export const waLink = (number, text = "") => {
  const n = waNormalize(number);
  if (!n) return "";
  const t = text ? `?text=${encodeURIComponent(text)}` : "";
  return `https://wa.me/${n}${t}`;
};

const WhatsAppFloat = () => {
  const { settings } = useSettings();
  const href = waLink(settings.whatsapp, "Merhaba, web sitenizden yazıyorum.");
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp ile iletişim"
      className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform hover:scale-105"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" />
    </a>
  );
};

export default WhatsAppFloat;
